import { z } from 'zod';
import { addressSchema } from '../../Address.js';
import { payableDataSchema } from '../../Payable.js';
import { pickupServiceConfigSchema } from '../configurations/PickupServiceConfig.js';
import { servicesProviderGenericDataSchema, supportObjectSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderPickupDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.PICKUP]: pickupServiceConfigSchema,
    }),
    physicalAddress: addressSchema,
    support: supportObjectSchema,
});

export { servicesProviderPickupDataSchema };
//# sourceMappingURL=ServicesProviderPickupData.js.map
